function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M32.9 12.217l-7.4-8.334a1.668 1.668 0 00-1.233-.55H10.933a4.217 4.217 0 00-4.266 4.166V32.5a4.217 4.217 0 004.266 4.167h18.134a4.217 4.217 0 004.266-4.166V13.333a1.667 1.667 0 00-.433-1.116zM23.333 25h-1.666v1.667a1.667 1.667 0 11-3.334 0V25h-1.666a1.667 1.667 0 110-3.333h1.666V20a1.667 1.667 0 113.334 0v1.667h1.666a1.667 1.667 0 110 3.333zm1.184-11.667a1.317 1.317 0 01-1.184-1.416v-5.25l6.234 6.666h-5.05z"
}));

var SvgNewDocument = function SvgNewDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNewDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-document.95990d27.svg";
export { ForwardRef as ReactComponent };